// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2xSGX","row":"Node_row__1kgCN","label":"Node_label__3NO9T","footer":"Node_footer__1u8Pb"};